import api from "api";
import {
  setAppointments,
  setAppointmentsSelected,
  setDates,
  setDrivers,
  setServices,
  setTrucks
} from "redux/assignment.slice";
import { ResponseTransform } from "utils";

export const getAppointments = ({idProject, idService, date}) => async (dispatch) => {
  const responseApi = await api.get(`/api/ShipmentPlan/project/${idProject}/carrier/${idService}/detail-approved?appointmentDate=${date}`).then(ResponseTransform);

  if (responseApi) {
    dispatch(setAppointments({ appointments : responseApi }));
    dispatch(setAppointmentsSelected([]));
  } else {
    dispatch(setAppointments({ appointments : [] }));
    dispatch(setAppointmentsSelected([]));
  }
  return responseApi;
};

export const getDates = ({idProject, idService}) => async (dispatch) => {
  const responseApi = await api.get(`/api/ShipmentPlan/project/${idProject}/carrier/${idService}/detail-approved/dates-filter`).then(ResponseTransform);

  if (responseApi) {
    const availableDates = responseApi.map(fecha => new Date(fecha));
    dispatch(setDates(availableDates));
  }
  return responseApi;
};

export const getServices = (idProject) => async (dispatch) => {
  const responseApi = await api.get(`api/ShipmentPlan/project/${idProject}/detail-approved/carriers-filter`).then(ResponseTransform);
  if (responseApi) {
    dispatch(setServices(responseApi));
  }
  return responseApi;
};

export const getTrucks = (idProject) => async (dispatch) => {
  const responseApi = await api.get(`api/Truck/project/${idProject}`).then(ResponseTransform);

  if (responseApi) {
    dispatch(setTrucks(responseApi));
  }
  return responseApi;
};

export const getDrivers = (idService) => async (dispatch) => {
  const responseApi = await api.get(`api/Operator/carrier/${idService}`).then(ResponseTransform);
  if (responseApi) {
    dispatch(setDrivers(responseApi));
  }
  return responseApi;
};

export const saveAssignment = (data) => async (dispatch) => {
  const responseApi = await api
    .post("api/Trip", data)
    .then(ResponseTransform);
  if (responseApi) {
    //dispatch(getAppointments());
    return true;
  }
  return responseApi;
};